export enum PublicationStatus {
    NOT_PUBLISHED = 'notPublished',
    PUBLISHED = 'published',
    UNPUBLISHED = 'unpublished',
}

export default PublicationStatus;
